import type * as llmApi from "../api/llm";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

interface ModelSelectProps {
  value: llmApi.LLMModel;
  onChange: (value: llmApi.LLMModel) => void;
  models: llmApi.LLMModel[];
}

export function ModelSelect({ value, onChange, models }: ModelSelectProps) {
  if (!models || models.length === 0 || !models[0]?.id) {
    console.error("models", models);
    return (
      <Select disabled>
        <SelectTrigger className="w-full">
          <SelectValue>モデルを読み込み中...</SelectValue>
        </SelectTrigger>
      </Select>
    );
  }

  return (
    <Select
      value={value.id}
      onValueChange={(selectedId) => {
        const selectedModel = models.find((model) => model.id === selectedId);
        if (selectedModel) {
          onChange(selectedModel);
        }
      }}
    >
      <SelectTrigger className="w-full">
        <SelectValue>{value.name}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {models.map((model) => (
          <SelectItem key={model.id} value={model.id}>
            {model.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
